// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qK2Xh__frame {
  position: relative;
  width: 100%;
  aspect-ratio: 1600 / 926;
  background: #000;
  overflow: hidden;
}

.eLN2w__video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.vAntb__overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  color: inherit;
  font: inherit;
}

.uxQDU__overlayButton {
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.6em 1.1em;
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  font-weight: 700;
  font-size: 1em;
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  transition: background 0.15s ease;
}

.vAntb__overlay:hover .uxQDU__overlayButton,
.vAntb__overlay:focus-visible .uxQDU__overlayButton {
  background: rgba(0, 0, 0, 0.75);
}
`, "",{"version":3,"sources":["webpack://./src/app/routes/news/PostVideo.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAQ;EAAR,QAAQ;EAAR,SAAQ;EAAR,OAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kCAA0B;UAA1B,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC","sourcesContent":[".frame {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1600 / 926;\n  background: #000;\n  overflow: hidden;\n}\n\n.video {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 0;\n  padding: 0;\n  background: transparent;\n  cursor: pointer;\n  color: inherit;\n  font: inherit;\n}\n\n.overlayButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5em;\n  padding: 0.6em 1.1em;\n  border-radius: 100px;\n  background: rgba(0, 0, 0, 0.55);\n  color: #fff;\n  font-weight: 700;\n  font-size: 1em;\n  backdrop-filter: blur(4px);\n  transition: background 0.15s ease;\n}\n\n.overlay:hover .overlayButton,\n.overlay:focus-visible .overlayButton {\n  background: rgba(0, 0, 0, 0.75);\n}\n"],"sourceRoot":""}]);
// Exports
export var frame = `qK2Xh__frame`;
export var video = `eLN2w__video`;
export var overlay = `vAntb__overlay`;
export var overlayButton = `uxQDU__overlayButton`;
export default ___CSS_LOADER_EXPORT___;
